import { render } from "./StatusCalculator.vue?vue&type=template&id=b7646078&scoped=true"
import script from "./StatusCalculator.vue?vue&type=script&lang=ts"
export * from "./StatusCalculator.vue?vue&type=script&lang=ts"

import "./StatusCalculator.vue?vue&type=style&index=0&id=b7646078&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b7646078"

export default script